import { apiGet, apiPost } from '../../../utils/http';

export default function generateSchoolCrud(toApiUrl) {
	const SUBMIT_FORM_URL = toApiUrl('/gym-agreement');
	const LOCATION_URL = id => toApiUrl(`/locations/${id}`);
	const CAPTCHA_URL = toApiUrl('/captcha');

	function submitForm(payload) {
		return apiPost(SUBMIT_FORM_URL, payload);
	}

	function getLocations(id) {
		return apiGet(LOCATION_URL(id));
	}

	function checkCaptcha(payload) {
		return apiPost(CAPTCHA_URL, payload);
	}

	return {
		submitForm,
		getLocations,
		checkCaptcha
	};
}
